module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof05"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Although Emperor Peter III promulgated the Charter of Liberties in 1762"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent16",
      "id": "theft16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" that abolished mandatory military service for nobles, the number of noblemen enlisting in the army kept increasing. The army was the only honorable career for young noblemen and the Russian monarchy created a hallowed tradition of service. By 1782, 108,000 male nobles in Russia had flooded the army."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent17",
      "id": "theft17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" New vacancies of supernumeraries (sverkhkomplektnye) were created because the regimental ranks were full. Eventually, the excess of supernumeraries, particularly of Guard officers, turned into a major problem. By 1792 there were 6,134 non-commissioned officers in the Life Guard Preobrazhensk Regiment and 3,502 privates. Although the Guard officially had vacancies for only 400 non-commissioned officers, the actual number of officers exceeded 11,500."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent18",
      "id": "theft18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" Therefore, large groups of officers were frequently appointed to regular units; 250 in 1782 and 400 in 1796."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent19",
      "id": "theft19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" The size of the Officer Corps varied during the Napoleonic Wars. In 1797 there were 399 generals, 297 colonels, 466 lieutenant colonels, and 1,654 majors; 12 years later there were 495 colonels, 442 lieutenant colonels, and 1,176 majors. The total size of the Officer Corps was 12,000 men in 1803, more than 14,000 from 1805 to 1807, and between 15,000 and 17,000 by 1812."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent20",
      "id": "theft20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Enlisted noblemen were usually conferred the rank of non-commissioned officer, but had to serve as a soldier for three months before actually receiving the rank. Patronage and nepotism played an important role in advancement. Many senior officers arranged for sons or relatives to serve in their units and receive promotions in a timely or expedited fashion. On average, noblemen served two months to three years to earn an officer’s rank. In 1812, 16.5% of officers in the First and Second Western Armies served two years as NCOs before earning an officer’s rank, 12.6% received the rank in a year, and 7.5% within several months of enlistment."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent21",
      "id": "theft21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" Civilians who transferred to the military service usually had their officer epaulettes within one to three years, depending on their previous civil rank and position. The timeline was considerably longer for non-nobles, who waited five to seven years before becoming an officer. NCOs from the soldier ranks were in the worst position, and usually served a decade or more before receiving an officer’s rank. In 1812, 64 out of these 92 officers had to serve between 10 and 25 years, while three of them remained in the NCO ranks for an incredible 24 to 27 years."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent22",
      "id": "theft22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Russian rulers established various regulations in attempts to improve the promotion process. Prior to 1742, candidates were selected by the vote (balotirovanie) of their fellow officers. Peter the Great established this process to ensure that promotions were based on merit. However, in 1726, Empress Catherine I abolished it because corruption and nepotism prevented objective voting. Instead, candidates were promoted based on merit and experience. Empress Anna Ioanovna revived the voting procedure with certain limitations in February 1731. Under new regulations, the Russian sovereign had to confirm officer transfers between regiments as well as any promotions to colonel. Five years later, Empress Anna made further changes to the system. She kept the voting process for junior and staff officer ranks, but senior officer ranks were awarded only on merit. Finally, in March 1742, Empress Elisabeth declared that promotions be made based on seniority and merit.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Junior officers and NCOs had their subsequent career chosen for them by their supervising colonel with evaluations in attestats (certificates of service). These documents were supposed to be signed by the candidate’s com rades before being sent to their superiors. However, some men signed whatever their commander showed them for fear of receiving a bad evaluation."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent23",
      "id": "theft23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" Thus, a commanding officer could determine the composition of his unit and indirectly influence the social composition of the officer corps by delaying promotions to non-nobles. Candidates had to pass military examinations to qualify for officer’s rank. In 1808, General Aleksey Arakcheyev established the Committee on Artillery to supervise artillery examinations and to ensure the quality of artillery officers. Similar exams also existed for other branches, but they were rarely enforced because of rampant favoritism."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent24",
      "id": "theft24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Differences also existed between ober (junior rank) and staff officer to senior rank promotions. Generals to captains could promote candidates to ober officer ranks. Only army commanders, field marshals, and the president of the War College could promote candidates to major and lieutenant colonel. The number of vacancies in each regiment limited these promotions. Staff officers could be transferred from their regiment to a vacancy in another unit. When a vacancy appeared, the most senior officer was promoted."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent25",
      "id": "theft25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" Therefore, dating seniority in ranks became extremely important, and often led to squabbles between officers of the same rank but different seniority. To accelerate their promotions, many officers transferred to units where they could receive a higher rank. Such transfers were particularly widespread in the artillery, where 80% of the officers changed regiments at least twice during their careers. Once they achieved senior rank, officers remained in their units for extended periods of time.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6702e6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof05.vue
// module id = 108
// module chunks = 0